import Cookies from 'js-cookie'

const TokenKey = 'system_token'
const UserInfoKey = 'system_userInfo'
const PermissionsKey = 'system_permissions'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserInfo() {
  const userInfo = localStorage.getItem(UserInfoKey)
  return userInfo ? JSON.parse(userInfo) : null
}

export function setUserInfo(userInfo) {
  return localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function removeUserInfo() {
  return localStorage.removeItem(UserInfoKey)
}

export function getPermissions() {
  const permissions = localStorage.getItem(PermissionsKey)
  return permissions ? JSON.parse(permissions) : []
}

export function setPermissions(permissions) {
  return localStorage.setItem(PermissionsKey, JSON.stringify(permissions))
}

export function removePermissions() {
  return localStorage.removeItem(PermissionsKey)
}
